import { render, staticRenderFns } from "./CollectionFiltersSkeleton.vue?vue&type=template&id=1c3947a2&scoped=true&lang=pug&"
import script from "./CollectionFiltersSkeleton.vue?vue&type=script&lang=js&"
export * from "./CollectionFiltersSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFiltersSkeleton.vue?vue&type=style&index=0&id=1c3947a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3947a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3947a2')) {
      api.createRecord('1c3947a2', component.options)
    } else {
      api.reload('1c3947a2', component.options)
    }
    module.hot.accept("./CollectionFiltersSkeleton.vue?vue&type=template&id=1c3947a2&scoped=true&lang=pug&", function () {
      api.rerender('1c3947a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionFiltersSkeleton.vue"
export default component.exports